import styled from "styled-components";
import { rgba, borderRadius } from "polished";
const InputGroupWrapper = styled("div")(({ theme }) => ({
  alignItems: "stretch",
  backgroundColor: "white",
  color: theme.color.default,
  display: "flex",
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  transform: "translateZ(0)"
}));
const InputGroupMain = styled("div")(
  ({ theme }) => ({
    alignItems: "stretch",
    borderRadius: 2,
    boxShadow: `inset 0 0 0 1px ${theme.controlBorderColor}`,
    display: "flex",
    flex: "1 1 0",
    position: "relative",
    transition: "0.3s",
    zIndex: 1,
    "&:hover": {
      boxShadow: `inset 0 0 0 1px ${theme.color.blue6}`
    },
    "&:focus-within": {
      borderColor: theme.color.blue6,
      boxShadow: `
        inset 0 0 0 1px ${theme.color.blue6},
        0 0 0 2px ${rgba(theme.color.blue6, 0.25)}
      `
    }
  }),
  ({ prefixed }) => prefixed ? borderRadius("left", 0) : void 0,
  ({ suffixed }) => suffixed ? borderRadius("right", 0) : void 0,
  ({ variant }) => ({
    input: {
      padding: "0 4px"
    }
  })[variant],
  ({ error, theme }) => error ? {
    "&, &:hover, &:focus-within": {
      boxShadow: `inset 0 0 0 1px ${theme.color.red6}`
    },
    "&:focus-within": {
      boxShadow: `
              inset 0 0 0 1px ${theme.color.red6},
              0 0 0 2px ${rgba(theme.color.red6, 0.25)}
            `
    }
  } : void 0,
  ({ disabled, theme }) => disabled ? {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    "&, &:hover": {
      boxShadow: `inset 0 0 0 1px ${theme.controlBorderColor}`
    }
  } : void 0
);
const InputGroupItem = styled("div")({
  alignItems: "stretch",
  flex: "1 1 0",
  position: "relative"
});
const InputGroupPrefix = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flex: "0 0 auto"
});
const InputGroupSeparator = styled("div")(
  {
    alignItems: "center",
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "center"
  },
  ({ content = "" }) => ({
    "&::before": {
      content: JSON.stringify(content)
    }
  })
);
const InputGroupSuffix = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flex: "0 0 auto"
});
export {
  InputGroupItem,
  InputGroupMain,
  InputGroupPrefix,
  InputGroupSeparator,
  InputGroupSuffix,
  InputGroupWrapper
};
